import React from "react";
import SmartContract from "../components/SmartContract";

function SmartContractContainer(props) {
  let smartContracts = props.SmartContracts;
  return (
    <div className="hoverBox OverviewContainer">
      {smartContracts.map((c) => {
        if (c) {
          return (
            <div key={c.ID}>
              <div>
                <SmartContract contract={c} />
              </div>
              <br />
              <hr />
            </div>
          );
        }
        return "";
      })}
    </div>
  );
}

export default SmartContractContainer;
